<script>
  export let direction = "top";

</script>

<div class="arrow {direction}">
			<div class="triangle" />
			<div class="cone" />
		</div>


<style>


	.arrow.top {
    width: 16px;
    height: 100%;
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
	}

	.arrow.top .cone {
		width: 50%;
		height: 100%;
		clip-path: polygon(100% 0%, 0% 0%, 50% 100%);
		background: #666;
	}

	.arrow.top .triangle {
		background: #666;
		width: 100%;
		height: 16px;
		clip-path: polygon(100% 100%, 0% 100%, 50% 0%);
  }

	.arrow.right {
    height: 16px;
    width: 100%;
		display: flex;
		flex-wrap: wrap;
    justify-content: center;
    flex-direction: row-reverse;
    align-items: center;
    flex-wrap: nowrap;
	}

	.arrow.right .cone {
		height: 50%;
		width: 100%;
		clip-path: polygon(0% 100%, 0% 0%, 100% 50%);
		background: #666;
    transform: rotate(180deg);
    transform-origin: center center;
	}

	.arrow.right .triangle {
		background: #666;
		height: 100%;
		width: 16px;
    clip-path: polygon(100% 100%, 100% 0, 0% 50%);
    transform: rotate(180deg);
    transform-origin: center center;
	}
</style>
